export const GENERATE_RANDOM_ARRAY = "GENERATE_RANDOM_ARRAY";
export const ARRAY_SORTED = "ARRAY_SORTED";
export const ARRAY_UPDATED = "ARRAY_UPDATED";
export const START_SORTING = "START_SORTING";
export const STOP_SORTING = "STOP_SORTING";
